import LeafletMapsContainer from "../../../../Components/Miscellaneous/Maps/LeafletMaps/leafletMapsContainer";

const LeafletMap = () => {
  return <LeafletMapsContainer />;
};

export default LeafletMap;
